// src/store/panelStore.js

/**
 * Dieser Store verwaltet den Zustand für das Mitarbeiter-Panel,
 * insbesondere den aktuell ausgewählten Kunden für einen Trainer.
 */
export const panelStore = {
  namespaced: true,
  state: {
    // Der Kunde, der im Panel für Aktionen ausgewählt ist.
    selectedCustomer: null,
  },
  getters: {
    /**
     * Gibt den aktuell ausgewählten Kunden zurück.
     * @param {object} state - Der Vuex-State.
     * @returns {object|null} Der ausgewählte Kunde oder null.
     */
    getSelectedCustomer(state) {
      return state.selectedCustomer
    },
  },
  mutations: {
    /**
     * Setzt oder löscht den ausgewählten Kunden im State.
     * @param {object} state - Der Vuex-State.
     * @param {object|null} customer - Das Kundenobjekt oder null.
     */
    setSelectedCustomer(state, customer) {
      // Stellt sicher, dass das Objekt reaktiv bleibt und keine Referenzen geteilt werden.
      state.selectedCustomer = customer ? JSON.parse(JSON.stringify(customer)) : null
    },
  },
  actions: {
    /**
     * Wählt einen Kunden aus und speichert ihn im Store.
     * @param {object} context - Das Vuex-Action-Context-Objekt.
     * @param {object} customer - Das auszuwählende Kundenobjekt.
     */
    selectCustomer({ commit }, customer) {
      commit("setSelectedCustomer", customer)
    },
    // setzt selectedCustomer.infos
    setCustomerInfos({ state, commit }, infos) {
      if (!state.selectedCustomer) {
        console.warn("Kein Kunde ausgewählt, Infos können nicht gesetzt werden.")
        return
      }
      const updatedCustomer = { ...state.selectedCustomer, infos: infos }
      commit("setSelectedCustomer", updatedCustomer)
    },
    /**
     * Hebt die Auswahl des aktuellen Kunden auf.
     * @param {object} context - Das Vuex-Action-Context-Objekt.
     */
    clearCustomer({ commit }) {
      commit("setSelectedCustomer", null)
    },
  },
}
